import { render, staticRenderFns } from "./SettingsForm.vue?vue&type=template&id=02ad18a8"
import script from "./SettingsForm.vue?vue&type=script&lang=ts"
export * from "./SettingsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports